export default "__VITE_ASSET__P4QLtpS2__"